import React, { useEffect, useRef, useState } from "react";
import urls from "../Utils/urls";
import { Link } from "react-router-dom";
import "../css/about.css";
import aboutus from "../images/aboutus.webp";
import { Helmet } from "react-helmet";

function useCountUp(target, duration = 2000, started = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!started) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration, started]);
  return count;
}

function StatNum({ num, prefix = "", suffix = "+", started }) {
  const count = useCountUp(num, 2000, started);
  return <>{prefix}{count.toLocaleString('en-IN')}{suffix}</>;
}

const IcoTarget  = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>;
const IcoEye     = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IcoShield  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>;
const IcoZap     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IcoUsers   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoIndia   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>;

const About = () => {
  const statsRef = useRef(null);
  const [statsStarted, setStatsStarted] = useState(false);

  const mvRef = useRef(null);
  const [mvStarted, setMvStarted] = useState(false);

  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setStatsStarted(true); obs.disconnect(); }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const el = mvRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setMvStarted(true); obs.disconnect(); }
    }, { threshold: 0.25 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const liveCount = useCountUp(50, 2000, mvStarted);
  const yearCount = useCountUp(2027, 2000, mvStarted);

  return (
    <>
      <Helmet>
        <title>Instant salary Loans for Salaried Professionals | Salary Uncle</title>
        <meta property="og:title" content="Instant salary Loans for Salaried Professionals | Salary Uncle" />
        <meta name="description" content="Get fast, fully digital salary loans with instant approval & minimal documents. Trusted NBFC for salaried professionals across India -- Apply in 10 mins!" />
        <meta property="og:description" content="Get fast, fully digital salary loans with instant approval & minimal documents. Trusted NBFC for salaried professionals across India -- Apply in 10 mins!" />
        <link rel="canonical" href={`${urls.SITE_URL}/about-us`} />
      </Helmet>

      {/* ── HERO ── */}
      <section className="ab-hero">
        <div className="ab-hero-left">
          <span className="ab-tag">RBI REGISTERED NBFC</span>
          <h1>Getting Salary Loans<br /><span>Online Made Easy</span></h1>
          <p>Salary Uncle is an RBI-registered NBFC, committed to providing instant approval salary loans, making your life seamless and hassle-free.</p>
          <a href="/apply-now" className="ab-hero-btn">Apply Now &nbsp;→</a>
        </div>
        <div className="ab-hero-right">
          <img src={aboutus} alt="Salary Uncle" />
        </div>
      </section>

      {/* ── STATS STRIP ── */}
      <div className="ab-stats-strip" ref={statsRef}>
        <div className="ab-stat">
          <div className="ab-stat-num"><StatNum num={15000} started={statsStarted} /></div>
          <div className="ab-stat-label">Loans Disbursed</div>
        </div>
        <div className="ab-stat">
          <div className="ab-stat-num"><StatNum num={50} prefix="₹" suffix="Cr+" started={statsStarted} /></div>
          <div className="ab-stat-label">Total Loan Amount</div>
        </div>
        <div className="ab-stat">
          <div className="ab-stat-num"><StatNum num={10000} started={statsStarted} /></div>
          <div className="ab-stat-label">Happy Customers</div>
        </div>
        <div className="ab-stat">
          <div className="ab-stat-num"><StatNum num={250} started={statsStarted} /></div>
          <div className="ab-stat-label">Finance Experts</div>
        </div>
      </div>

      {/* ── OUR STORY ── */}
      <section className="ab-story">
        <div className="ab-story-bg-shape ab-story-shape-1"></div>
        <div className="ab-story-bg-shape ab-story-shape-2"></div>

        <div className="ab-story-inner">
          <div className="ab-story-head">
            <div className="ab-story-tag">OUR STORY</div>
            <h2>Building Financial <span className="highlight">Bridges</span> for Every Salaried Indian</h2>
            <p className="ab-story-sub">Empowering professionals with instant access to credit — because financial freedom should never wait.</p>
          </div>

          <div className="ab-story-grid">
            {/* LEFT: Story Content */}
            <div className="ab-story-content">
              <p className="ab-story-lead">At Salary Uncle, we understand that financial needs can arise anytime — whether it is an emergency or the pursuit of personal aspirations.</p>
              <p>As a tech-driven NBFC in India, we specialize in offering salary loans online with fast, secure, and fully digital loan approval for salaried professionals. Our AI-powered platform eliminates paperwork delays and branch visits — bringing instant credit to your fingertips, 24/7.</p>
              <p>Born from a simple idea — that every working professional deserves quick access to funds without bureaucratic hurdles — we have grown into one of India's most trusted digital lending platforms, processing thousands of loans every month with industry-leading approval times.</p>

              <div className="ab-story-features">
                <div className="ab-story-feat">
                  <div className="ab-story-feat-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div>
                    <div className="ab-story-feat-t">100% Digital Process</div>
                    <div className="ab-story-feat-d">From application to disbursement — no branch visits required.</div>
                  </div>
                </div>
                <div className="ab-story-feat">
                  <div className="ab-story-feat-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div>
                    <div className="ab-story-feat-t">AI-Powered Approval</div>
                    <div className="ab-story-feat-d">Smart algorithms evaluate your eligibility in real time.</div>
                  </div>
                </div>
                <div className="ab-story-feat">
                  <div className="ab-story-feat-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div>
                    <div className="ab-story-feat-t">Bank-Grade Security</div>
                    <div className="ab-story-feat-d">256-bit encryption protects every transaction & document.</div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT: Visual Stats Card */}
            <div className="ab-story-visual">
              <div className="ab-story-card">
                <div className="ab-story-card-head">
                  <div className="ab-story-card-tag">SINCE 2020</div>
                  <h3>Trusted by India's<br />Working Professionals</h3>
                </div>

                <div className="ab-story-card-stats">
                  <div className="ab-story-cs-item">
                    <div className="ab-story-cs-num">98%</div>
                    <div className="ab-story-cs-label">Approval Rate</div>
                  </div>
                  <div className="ab-story-cs-item">
                    <div className="ab-story-cs-num">4.8/5</div>
                    <div className="ab-story-cs-label">Customer Rating</div>
                  </div>
                  <div className="ab-story-cs-item">
                    <div className="ab-story-cs-num">10 Min</div>
                    <div className="ab-story-cs-label">Avg Approval</div>
                  </div>
                  <div className="ab-story-cs-item">
                    <div className="ab-story-cs-num">24/7</div>
                    <div className="ab-story-cs-label">Online Access</div>
                  </div>
                </div>

                <div className="ab-story-card-quote">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="#509540"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2-1 0-1 .75-1 2v1c0 1 .75 1 1 1zm12 0c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2-1 0-1 .75-1 2v1c0 1 .75 1 1 1z"/></svg>
                  <p>"We don't just lend money — we build trust, one loan at a time."</p>
                  <span>— Salary Uncle Team</span>
                </div>
              </div>
            </div>
          </div>

          <div className="ab-pillars">
            {[
              { icon: <IcoShield />, t: "RBI Regulated",  d: "Fully compliant NBFC",     link: "/about/rbi-regulated" },
              { icon: <IcoZap />,    t: "10-Min Approval", d: "Industry-leading speed",  link: "/about/10-min-approval" },
              { icon: <IcoUsers />,  t: "50K+ Customers",  d: "Trusted nationwide",      link: "/about/customers" },
              { icon: <IcoIndia />,  t: "Pan India",       d: "Available 28 states",     link: "/about/pan-india" },
            ].map((p, i) => (
              <Link to={p.link} className="ab-pillar" key={i}>
                <div className="ab-pillar-icon">{p.icon}</div>
                <div className="ab-pillar-text">
                  <span className="ab-pillar-t">{p.t}</span>
                  <span className="ab-pillar-d">{p.d}</span>
                </div>
                <div className="ab-pillar-arrow">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── MISSION & VISION ── */}
      <section className="ab-mv">
        <div className="ab-mv-bg-shape ab-mv-shape-1"></div>
        <div className="ab-mv-bg-shape ab-mv-shape-2"></div>

        <div className="ab-mv-head">
          <div className="ab-mv-tag">PURPOSE & DIRECTION</div>
          <h2>Driven by <span className="highlight">Purpose</span>, Guided by <span className="highlight">Vision</span></h2>
          <p>What we stand for and where we are headed — the principles that shape every decision at Salary Uncle.</p>
        </div>

        <div className="ab-mv-inner" ref={mvRef}>
          {/* MISSION */}
          <div className="ab-mv-card ab-mv-mission">
            <div className="ab-mv-card-top">
              <div className="ab-mv-icon-wrap">
                <div className="ab-mv-icon-bg"></div>
                <div className="ab-mv-icon"><IcoTarget /></div>
              </div>
              <div className="ab-mv-label">01 — OUR MISSION</div>
            </div>
            <h3>Empowering Every Salaried Indian</h3>
            <p>To simplify personal finance for salaried professionals by offering fast, flexible, and fully digital salary loans — delivering instant loan solutions with integrity and speed across India.</p>
            <ul className="ab-mv-list">
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Make credit accessible to every working professional
              </li>
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Eliminate paperwork through 100% digital lending
              </li>
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Deliver transparency in every transaction
              </li>
            </ul>
            <div className="ab-mv-footer">
              <div className="ab-mv-foot-num">{liveCount}K+</div>
              <div className="ab-mv-foot-txt">Lives impacted through our mission</div>
              <div className="ab-mv-foot-anim" aria-hidden="true">
                <svg viewBox="0 0 140 90">
                  <defs>
                    <linearGradient id="abBarGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#6dd05a"/>
                      <stop offset="100%" stopColor="#3d7a30"/>
                    </linearGradient>
                    <linearGradient id="abFillGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#6dd05a" stopOpacity="0.25"/>
                      <stop offset="100%" stopColor="#509540" stopOpacity="0"/>
                    </linearGradient>
                    <filter id="abGlow" x="-50%" y="-50%" width="200%" height="200%">
                      <feGaussianBlur stdDeviation="1.5" result="blur"/>
                      <feMerge>
                        <feMergeNode in="blur"/>
                        <feMergeNode in="SourceGraphic"/>
                      </feMerge>
                    </filter>
                  </defs>

                  {/* Grid baseline */}
                  <line x1="6" y1="78" x2="134" y2="78" stroke="#d8eed2" strokeWidth="1" strokeDasharray="2 3"/>

                  {/* Bars */}
                  <rect className="ab-bar ab-bar1" x="10"  y="60" width="14" height="18" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar2" x="32"  y="50" width="14" height="28" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar3" x="54"  y="38" width="14" height="40" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar4" x="76"  y="26" width="14" height="52" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar5" x="98"  y="14" width="14" height="64" rx="3" fill="url(#abBarGrad)" />

                  {/* Area fill under the curve */}
                  <path className="ab-area" d="M17 56 Q 39 50, 61 38 T 105 12 L 105 78 L 17 78 Z" fill="url(#abFillGrad)"/>

                  {/* Trend curve */}
                  <path className="ab-curve" d="M17 56 Q 39 50, 61 38 T 105 12" fill="none" stroke="#509540" strokeWidth="2.6" strokeLinecap="round" filter="url(#abGlow)"/>

                  {/* Dots at data points */}
                  <circle className="ab-dot ab-dot1" cx="17"  cy="56" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot2" cx="39"  cy="48" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot3" cx="61"  cy="38" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot4" cx="83"  cy="24" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot5" cx="105" cy="12" r="3.5" fill="#509540" stroke="#fff" strokeWidth="2"/>

                  {/* Arrow head */}
                  <g className="ab-arrow-head">
                    <path d="M105 12 L 120 4" fill="none" stroke="#509540" strokeWidth="2.6" strokeLinecap="round"/>
                    <polyline points="113,2 122,2 122,11" fill="none" stroke="#509540" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>

                  {/* Sparkle */}
                  <g className="ab-sparkle">
                    <circle cx="118" cy="6" r="1.6" fill="#6dd05a"/>
                  </g>
                </svg>
              </div>
            </div>
          </div>

          {/* VISION */}
          <div className="ab-mv-card ab-mv-vision">
            <div className="ab-mv-card-top">
              <div className="ab-mv-icon-wrap">
                <div className="ab-mv-icon-bg"></div>
                <div className="ab-mv-icon"><IcoEye /></div>
              </div>
              <div className="ab-mv-label">02 — OUR VISION</div>
            </div>
            <h3>India's Most Trusted Lending Platform</h3>
            <p>To become India's most trusted digital lending platform — where getting a salary loan is as simple as making a digital payment: instant, secure, and completely transparent.</p>
            <ul className="ab-mv-list">
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Reach 1 Million+ customers across India by 2027
              </li>
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Pioneer AI-driven instant approval technology
              </li>
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Set new industry standards for ethical lending
              </li>
            </ul>
            <div className="ab-mv-footer">
              <div className="ab-mv-foot-num">{yearCount}</div>
              <div className="ab-mv-foot-txt">Target year for nationwide expansion</div>
              <div className="ab-mv-foot-anim" aria-hidden="true">
                <svg viewBox="0 0 140 90">
                  <defs>
                    <linearGradient id="abBarGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#6dd05a"/>
                      <stop offset="100%" stopColor="#3d7a30"/>
                    </linearGradient>
                    <linearGradient id="abFillGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#6dd05a" stopOpacity="0.25"/>
                      <stop offset="100%" stopColor="#509540" stopOpacity="0"/>
                    </linearGradient>
                    <filter id="abGlow" x="-50%" y="-50%" width="200%" height="200%">
                      <feGaussianBlur stdDeviation="1.5" result="blur"/>
                      <feMerge>
                        <feMergeNode in="blur"/>
                        <feMergeNode in="SourceGraphic"/>
                      </feMerge>
                    </filter>
                  </defs>

                  {/* Grid baseline */}
                  <line x1="6" y1="78" x2="134" y2="78" stroke="#d8eed2" strokeWidth="1" strokeDasharray="2 3"/>

                  {/* Bars */}
                  <rect className="ab-bar ab-bar1" x="10"  y="60" width="14" height="18" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar2" x="32"  y="50" width="14" height="28" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar3" x="54"  y="38" width="14" height="40" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar4" x="76"  y="26" width="14" height="52" rx="3" fill="url(#abBarGrad)" />
                  <rect className="ab-bar ab-bar5" x="98"  y="14" width="14" height="64" rx="3" fill="url(#abBarGrad)" />

                  {/* Area fill under the curve */}
                  <path className="ab-area" d="M17 56 Q 39 50, 61 38 T 105 12 L 105 78 L 17 78 Z" fill="url(#abFillGrad)"/>

                  {/* Trend curve */}
                  <path className="ab-curve" d="M17 56 Q 39 50, 61 38 T 105 12" fill="none" stroke="#509540" strokeWidth="2.6" strokeLinecap="round" filter="url(#abGlow)"/>

                  {/* Dots at data points */}
                  <circle className="ab-dot ab-dot1" cx="17"  cy="56" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot2" cx="39"  cy="48" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot3" cx="61"  cy="38" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot4" cx="83"  cy="24" r="3" fill="#fff" stroke="#509540" strokeWidth="2"/>
                  <circle className="ab-dot ab-dot5" cx="105" cy="12" r="3.5" fill="#509540" stroke="#fff" strokeWidth="2"/>

                  {/* Arrow head */}
                  <g className="ab-arrow-head">
                    <path d="M105 12 L 120 4" fill="none" stroke="#509540" strokeWidth="2.6" strokeLinecap="round"/>
                    <polyline points="113,2 122,2 122,11" fill="none" stroke="#509540" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>

                  {/* Sparkle */}
                  <g className="ab-sparkle">
                    <circle cx="118" cy="6" r="1.6" fill="#6dd05a"/>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="ab-cta">
        <h2>Experience Financial Freedom Today</h2>
        <p>Join thousands of satisfied customers who have experienced instant loans at their fingertips.</p>
        <div className="ab-cta-btns">
          <a href="/apply-now" className="ab-btn-primary">Apply For a Loan</a>
          <a href="/contact" className="ab-btn-outline">Contact Our Team</a>
        </div>
      </section>
    </>
  );
};

export default About;
